import Vue from "vue";

/**
 * Class Profile Service
 */
export default class HeroService extends Vue {
    
    private customActions = {
        showMetrics: { method: 'GET', url: 'auth/hero-metrics/{id_platform}/{id_user}' },
        show: { method: 'GET', url: 'auth/heroes-rules/{id_platform}/{id_user}' },
        store: { method: 'POST', url: 'auth/heroes-rules/' },
    };
    
    private resource: any = this.$resource('auth/heroes-rules/', {}, this.customActions);

    public async showMetrics(id_platform: number, id_user: number) {
        return await this.resource.showMetrics({ id_platform, id_user }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    public async show(id_platform:number, id_user: number) {
        return await this.resource.show({ id_platform, id_user }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
    
    public store(params: any) {
        return this.resource.store(params).then((response: any) => {
            return response.json();
        }, (response: any) => {
            return response.json();
        });
    }
}